import React, { useState, useEffect } from 'react';
import '../styles/Faq.css';

const FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    useEffect(() => {
        document.title = "Vanliga Frågor - Umrah Bröderna";
        const metaDescription = document.createElement('meta');
        metaDescription.name = "description";
        metaDescription.content = "Vanliga frågor och svar om våra Umrah-paket. Få all information du behöver för att planera din andliga resa till Mecka och Medina.";
        document.head.appendChild(metaDescription);

        return () => {
            document.head.removeChild(metaDescription);
        };
    }, []);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="faq-container">
            {/* 🏷️ Den vita FAQ-boxen innehåller både h1 och frågorna */}
            <section className="faq-content">
                <header className="faq-header">
                    <h1>Vanliga frågor och svar</h1>
                </header>
                
                {faqData.map((item, index) => (
                    <div key={index} className="faq-item">
                        <h2 
                            className={activeIndex === index ? 'active' : ''}
                            onClick={() => toggleFAQ(index)}
                        >
                            {item.question}
                        </h2>
                        <p className={`faq-answer ${activeIndex === index ? 'active' : ''}`}>
                            {item.answer}
                        </p>
                    </div>
                ))}
            </section>
        </div>
    );
};

const faqData = [
    { question: "Hur bokar jag?", answer: "Alla våra bokningar görs via vår webbplats. Om du har frågor kan du också ringa oss, och vi kommer att vägleda dig över telefon om hur du bokar på vår webbplats." },
    { question: "Hur bokar jag för mig och mitt barn?", answer: "Du kan göra en bokning för dig själv och sedan göra en separat bokning för ditt barn med dina egna kontaktuppgifter. Vårt bokningssystem tillåter att du anger dina uppgifter som kontaktperson även om du bokar för ditt barn. I det här fallet räknas ditt barn som resenär." },
    { question: "Vad innebär antalet personer i ett rum?", answer: "Ifall du bokar för exempelvis 4 personer i ett rum innebär det att du bokar ett rum för totalt 4 personer. Ifall du reser ensam kommer Umrah Bröderna att hjälpa dig att välja dina rumskamrater. Om du har särskilda önskemål om rumskamrater, vänligen informera oss när du blir kontaktad efter att du har genomfört din bokning." },
    { question: "Hur kan jag kontakta er?", answer: "Du kan nå oss via vår chatt på webbplatsen, via e-post till info@umrahbroderna.se eller via telefon på 010 470 00 81. Våra telefontider är alla dagar mellan 12.00 och 18.00." },
    { question: "Binder jag upp mig när jag bokar på webbplatsen?", answer: "Nej, din bokning säkerställer endast din plats, och du har inte bundit upp dig på något sätt. När du slutför din betalning har du säkrat din plats." },
    { question: "Vad händer efter att jag har bokat via webbplatsen?", answer: "Du kommer att inom kort få en faktura från oss för din bokning för att säkerställa din plats. Efter betalningen är klar och kommit in så kan du slappna av och luta dig bak då vi hanterar resten." },
    { question: "Finns det kvinnliga reseledare?", answer: "Ja, vi har välutbildade kvinnliga reseledare. Våra kvinnliga reseledare kommer att vara med dig före och under resan. De kommer att besvara dina frågor, vara tillgängliga för hjälp och utföra Umrah tillsammans med dig." },
    { question: "När får jag bekräftelse på att jag har betalat?", answer: "Du kommer att få en fakturabekräftelse med information om att din betalning har mottagits via mejl." },
    { question: "Kan jag avboka?", answer: "Ja, du har möjlighet att avboka din resa. Vid avbokningar gäller följande regler: 4 veckor innan avresa: 2 500 kr avgift. 2 veckor innan avresa: 7 000 kr avgift. 1 vecka innan avresa: 75% av paketkostnaden." },
    { question: "Måste jag ändå betala även om jag har en giltig anledning?", answer: "Nej, om avbokningen sker med fyra veckor eller mindre innan avresan och du kan visa upp en giltig anledning." },
    { question: "Vad räknas som en giltig anledning för avbokning?", answer: "En giltig anledning kräver ett läkarintyg som klargör att resan kan ha allvarliga konsekvenser för din hälsa." },
    { question: "Måste jag ange mina riktiga uppgifter vid bokningen?", answer: "Ja, det är viktigt att alltid ange korrekta uppgifter, inklusive fullständigt namn, telefonnummer och e-postadress m.m." },
    { question: "Vilken åldersgräns gäller för att få delta?", answer: "Det finns ingen fastställd åldersgräns. Om du är under 18 år och reser utan dina föräldrars tillåtelse, måste du följa svensk lag." },
    { question: "Kan jag resa som ensam kvinna?", answer: "Ja, ensamma kvinnor är välkomna att resa med oss. Vi följer svenska lagar och respekterar även de saudiska lagarna vid ankomsten till landet." },
    { question: "Var hittar jag betalningsinformationen?", answer: "Efter att du har bokat ett av våra paket kommer du att få en faktura skickad till din mejladress du angivit som du kan betala in ." }
];

export default FAQ;
